import { Container, TextField } from "@mui/material";


function TextBox({height, width, value, handleValueChange}) {
    return <TextField   onChange={handleValueChange} id="outlined-basic" value={value} multiline inputProps={{paddingTop: 0, style: {minHeight: `${height}px`, maxHeight: `${height}px`, minWidth: `${width}px`, maxWidth: `${width}px`, textAlign: 'left'} }} variant="outlined" />
}

export default TextBox;